export type TImageConfig = {
    section: string,
    category: string,
    name: string | number,
    extension: 'png' | 'webp',
}

const prepareBannerImage = ({ section, category, name, extension }: TImageConfig) =>
    `/static/images/internet/v2/banners/${section}/${category}/${name}.${extension}`;

export default prepareBannerImage;
